import {
  ArrowsChevronUp,
  ArrowsChevronDown,
} from "@fanduel/formation-react-icons";
import { fanduel as fd } from "@fanduel/formation-tokens";
import styles from "./Expand.module.scss";

type ExpandProps = {
  expanded: boolean;
  handleExpand: () => void;
  handleCollapse: () => void;
};

const Expand = ({ expanded, handleExpand, handleCollapse }: ExpandProps) =>
  expanded ? (
    <button className={styles.container} onClick={handleCollapse}>
      Collapse Table
      <ArrowsChevronUp color={fd.colors.coreWhite} />
    </button>
  ) : (
    <button className={styles.container} onClick={handleExpand}>
      View Full Table
      <ArrowsChevronDown color={fd.colors.coreWhite} />
    </button>
  );

export default Expand;
